const sk = {
  pleaseEnterUsername: "Prosím, zadajte používateľské meno",
  cannotFriendYourself: "Nemôžete poslať žiadosť o priateľstvo sami sebe.",
  friendRequestSent: "Žiadosť o priateľstvo bola odoslaná!",
  failedToSendRequest: "Nepodarilo sa odoslať žiadosť",
  linkCopied: "Odkaz bol skopírovaný do schránky!",
  backToInvites: "Späť na pozvánky",
  sendFriendRequestByUsername: "Poslať žiadosť o priateľstvo podľa používateľského mena",
  enterUsername: "Zadajte používateľské meno",
  send: "Odoslať",
  yourInviteQrCode: "Váš QR kód pozvánky",
  inviteLink: "Odkaz na pozvánku",
  scanQrOrUseLink: "Naskenujte tento QR kód alebo použite tento odkaz na odoslanie žiadosti o priateľstvo",
  copyInviteLink: "Kopírovať odkaz na pozvánku",
  goToItem: "Prejsť na položku",
  verificationEmailSent: "Overovací e-mail bol odoslaný! Skontrolujte svoju doručenú poštu.",
  verificationEmailFailed: "Nepodarilo sa odoslať overovací e-mail. Skúste to znova.",
  verifyYourEmail: "Overte svoju e-mailovú adresu",
  verifyEmailInstructions: "Prosím, overte svoju e-mailovú adresu pre prístup k svojmu účtu. Skontrolujte doručenú poštu a nájdite odkaz na overenie.",
  sending: "Odosiela sa...",
  resendVerificationEmail: "Znova odoslať overovací e-mail",
  login: "Prihlásiť sa",
  register: "Registrovať sa",
  home: "Domov",
  calendar: "Kalendár",
  friends: "Priatelia",
  profile: "Profil",
  logout: "Odhlásiť sa",
  loading: "Načítava sa...",
  language: "Jazyk",
  calendarSelectPlaceSuggestion: "Vyberte miesto z návrhov, aby sa pripojili súradnice.",
  calendarSelectDateAndTime: "Vyberte dátum a čas.",
  calendarPositiveDuration: "Zadajte kladné trvanie.",
  calendarFutureDateRequired: "Dátum a čas udalosti musia byť v budúcnosti.",
  calendarCreateEventFailed: "Nepodarilo sa vytvoriť udalosť. Skúste to znova.",
  cancel: "Zrušiť",
  createNewEvent: "Vytvoriť novú udalosť",
  week: "Týždeň",
  month: "Mesiac",
  eventTitle: "Názov",
  date: "Dátum",
  time: "Čas",
  duration: "Trvanie",
  endsAt: "Končí o",
  place: "Miesto",
  searchForPlace: "Vyhľadať miesto",
  placeSearchTip: "Tip: začnite písať a vyberte výsledok na pripojenie súradníc.",
  description: "Popis",
  createEvent: "Vytvoriť udalosť",
  today: "Dnes",
  previousMonth: "Predchádzajúci mesiac",
  nextMonth: "Nasledujúci mesiac",
  previous: "Predchádzajúci",
  next: "Nasledujúci",
  mondayShort: "Po",
  tuesdayShort: "Ut",
  wednesdayShort: "St",
  thursdayShort: "Št",
  fridayShort: "Pi",
  saturdayShort: "So",
  sundayShort: "Ne",
  more: "viac",
  mustRespondWillBeforeReposting: "Pred opätovným zdieľaním musíte odpovedať „Zúčastním sa“",
  event: "Udalosť",
  backToCalendar: "Späť do kalendára",
  addToGoogleCalendar: "Pridať do Kalendára Google",
  when: "Kedy",
  where: "Kde",
  openLocationInGoogleMaps: "Otvoriť polohu v Mapách Google",
  hosts: "Organizátori",
  yourResponse: "Vaša odpoveď",
  currentResponse: "Aktuálna odpoveď",
  response_will: "Zúčastním sa",
  response_might: "Možno sa zúčastním",
  response_wont: "Nezúčastním sa",
  willRunIntoYou: "Zastavím sa",
  mightDropBy: "Možno sa zastavím",
  wontCome: "Neprídem",
  repostToMyFriends: "Zdieľať priateľom",
  responses: "Odpovede",
  willAttend: "Zúčastní sa",
  reposted: "Zdieľané",
  mightAttend: "Možno sa zúčastní",
  cancelEvent: "Zrušiť udalosť",
  cancellationEmailNoticeBefore: "Účastníci, ktorí potvrdili účasť,",
  cancellationEmailNoticeAfter: "budú informovaní e-mailom o zrušení.",
  optionalCancellationMessage: "Voliteľná správa pre účastníkov (maximálne 1000 znakov)",
  confirmCancelEvent: "Potvrdiť zrušenie udalosti",
  clear: "Vymazať",
  confirmCancellation: "Potvrdiť zrušenie",
  confirmCancellationMessage: "Naozaj chcete zrušiť túto udalosť? Potvrdení účastníci budú upozornení a udalosť bude odstránená.",
  eventCancelledNotified: "Udalosť zrušená. Informovaní:",
  attendees: "účastníci",
  failedToCancelEvent: "Nepodarilo sa zrušiť udalosť",
  back: "Späť",
  cancelled: "Zrušené",
  ok: "OK",
  forgotPassword: "Zabudnuté heslo",
  email: "E-mail",
  passwordResetLinkSent: "Ak účet existuje, bol odoslaný odkaz na obnovenie hesla.",
  passwordResetRequestFailed: "Nepodarilo sa požiadať o obnovenie hesla.",
  sendResetLink: "Odoslať odkaz na obnovenie",
  addFriend: "Pridať priateľa",
  incomingRequests: "Prijaté žiadosti",
  accept: "Prijať",
  deny: "Odmietnuť",
  myFriends: "Moji priatelia",
  noFriendsYet: "Zatiaľ nemáte žiadnych priateľov. Začnite si ich pridávať!",
  seeProfile: "Zobraziť profil",
  noEventsToRespondTo: "Žiadne udalosti na odpoveď",
  allCaughtUp: "Ste v obraze. Vráťte sa neskôr pre nové udalosti od priateľov.",
  events: "Udalosti",
  unknown: "Neznáme",
  noDescriptionProvided: "Popis nebol poskytnutý.",
  will: "Áno",
  maybe: "Možno",
  wont: "Nie",
  userNotFound: "Používateľ nebol nájdený",
  friendRequestSentSuccessfully: "Žiadosť o priateľstvo bola úspešne odoslaná!",
  friendInvitation: "Pozvánka na priateľstvo",
  sendFriendRequest: "Poslať žiadosť o priateľstvo",
  loginToSendFriendRequest: "Prihláste sa, aby ste mohli odoslať žiadosť o priateľstvo",
  chooseLanguage: "Vybrať jazyk",
  invalidCredentials: "Neplatné prihlasovacie údaje. Skúste to znova.",
  username: "Používateľské meno",
  password: "Heslo",
  forgotPasswordQuestion: "Zabudli ste heslo?",
  dontHaveAccount: "Nemáte účet?",
  registerHere: "Zaregistrujte sa tu",
  invalidProfilePhotoType: "Neplatný typ súboru. Nahrajte obrázok JPEG, PNG, GIF alebo WebP.",
  invalidFileExtension: "Neplatná prípona súboru",
  allowedExtensions: "Povolené",
  fileTooLarge: "Súbor je príliš veľký",
  maximumFileSize: "Maximum",
  profilePhotoRemoved: "Profilová fotografia bola odstránená.",
  failedToRemoveProfilePhoto: "Nepodarilo sa odstrániť profilovú fotografiu",
  profileUpdatedSuccessfully: "Profil bol úspešne aktualizovaný!",
  failedToUpdateProfile: "Nepodarilo sa aktualizovať profil",
  privateEmailExplanation: "Iba vy môžete vidieť svoju e-mailovú adresu, aby ste sa vyhli nevyžiadaným správam mimo platformy",
  yourEmailIsPrivate: "Vaša e-mailová adresa je súkromná.",
  profilePhoto: "Profilová fotografia",
  removePhoto: "Odstrániť fotografiu",
  firstName: "Meno",
  lastName: "Priezvisko",
  tellPeopleAboutYourself: "Povedzte o sebe ostatným",
  whereToContactMe: "Ako ma kontaktovať",
  contactInfoPlaceholder: "Instagram: myUsername\nDiscord: myDiscord",
  save: "Uložiť",
  notSet: "Nenastavené",
  editProfile: "Upraviť profil",
  imageToCrop: "Obrázok na orezanie",
  zoom: "Priblíženie",
  usePhoto: "Použiť fotografiu",
  name: "Meno",
  whereToContact: "Kontakt",
  removeFriendship: "Odstrániť priateľstvo",
  confirmRemoveFriend: "Potvrdiť odstránenie priateľa",
  confirmRemoveFriendBefore: "Naozaj chcete odstrániť",
  confirmRemoveFriendAfter: "zo svojho zoznamu priateľov?",
  friendRemoved: "Priateľ bol odstránený.",
  failedToRemoveFriend: "Nepodarilo sa odstrániť priateľa.",
  confirmRemove: "Potvrdiť odstránenie",
  error: "Chyba",
  removed: "Odstránené",
  passwordsDoNotMatch: "Heslá sa nezhodujú",
  registrationFailed: "Registrácia zlyhala. Skúste to znova.",
  confirmPassword: "Potvrdiť heslo",
  alreadyHaveAccount: "Už máte účet?",
  loginHere: "Prihláste sa tu",
  passwordResetSuccessfully: "Heslo bolo úspešne obnovené.",
  failedToResetPassword: "Nepodarilo sa obnoviť heslo.",
  resetPassword: "Obnoviť heslo",
  newPassword: "Nové heslo",
  confirmNewPassword: "Potvrdiť nové heslo",
  setNewPassword: "Nastaviť nové heslo",
  emailVerifiedSuccessfully: "E-mail bol úspešne overený!",
  emailVerificationFailed: "Overenie zlyhalo. Odkaz môže byť neplatný alebo expirovaný.",
  verifying: "Overuje sa...",
  verified: "Overené!",
  redirectingToHome: "Presmerovanie na domovskú stránku...",
  verificationFailed: "Overenie zlyhalo",
  goToHome: "Prejsť na domovskú stránku",
  about: "O aplikácii",
  aboutConceptTitle: "Koncept",
  aboutCreatorIntroduction: "Ahoj, som Crypt0, lezec a tvorca Run Into Me.",
  aboutCreatorStory: "Túto stránku som vytvoril, pretože som spoločenský a trávil som priveľa času organizovaním spoločného lezenia.",
  aboutPlanningProblem: "Chcel som všetkým naraz oznámiť, kedy a kde budem liezť, bez formálnej pozvánky.",
  aboutDeveloperSolution: "Potom som si spomenul, že som vývojár a riešenie môžem vytvoriť sám.",
  aboutWelcome: "Vitajte v Run Into Me, kde priateľom oznámite aktivity, ku ktorým sa môžu bez nátlaku pridať.",
  aboutCallToAction: "Zverejnite tu ďalšiu aktivitu, ktorá je zábavnejšia spolu!",
  aboutTutorialTitle: "Návod",
  aboutCalendarCreateEvent: "Na obrazovke Kalendár môžete vytvoriť aj novú udalosť.",
  aboutEventColorsIntroduction: "Farby označujú stav účasti:",
  aboutColorGold: "Zlatá",
  aboutColorGoldDescription: "Udalosť organizujete.",
  aboutColorGreen: "Zelená",
  aboutColorGreenDescription: "Udalosti sa zúčastníte.",
  aboutColorOrange: "Oranžová",
  aboutColorOrangeDescription: "Odpovedali ste „možno“.",
  aboutColorBlue: "Modrá",
  aboutColorBlueDescription: "Zatiaľ ste neodpovedali.",
  aboutColorGray: "Sivá",
  aboutColorGrayDescription: "Pozvánku ste odmietli.",
  aboutCalendarEventDetails: "Kliknutím zobrazíte podrobnosti a odpoviete.",
  aboutFriendPageTitle: "Stránka priateľov",
  aboutFriendPageDescription: "Zadajte používateľské meno alebo odošlite odkaz / QR kód.",
  aboutHomePageTitle: "Domovská stránka",
  aboutHomePageDescription: "Prezerajte udalosti a oznámte účasť.",
  aboutRepostScreenTitle: "Obrazovka opätovného zdieľania",
  aboutGoogleCalendarDescription: "Týmto tlačidlom pridáte udalosť do Kalendára Google.",
  aboutRepostDescription: "Po potvrdení môžete udalosť zdieľať priateľom.",
};

export default sk;